import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import SearchResultsViewer from './MiniCart';
import { Button } from '../General/Button';
import { OutsideClick } from '../../Defaults/OutsideClick';

// Interfaces

/*****************/

const SearchFormWrapper = styled.form`
  width: 100%;
`;

const SearchFormContainer = styled.div`
  display: flex;
  position: relative;
`;

const SearchFormInputWrapper = styled.div`
  flex: 1 0 auto;
  position: relative;
`;

const SearchFormSubmit = styled(Button)`
  transition: filter 0.2s ease;

  &:hover {
    filter: brightness(90%);
  }

  ${({ theme }) => theme.media(0, 'sm')} {
    display: none;
  }
`;

export const SearchFormIcon: any = styled.img`
  fill: #111111;
  position: absolute;
  top: 50%;
  left: ${rem(15)};
  transform: translate3d(0, -50%, 0);
  width: ${rem(24)};
  height: ${rem(24)};
`;

function MiniCartWrapper() {
  return <SearchResultsViewer />;
}

export { MiniCartWrapper };
